module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjE1MSIgdmlld0JveD0iMCAwIDMwMSAxNTEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjNkNGIiBkPSJNLjUuNWgzMDB2MTUwSC41eiIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0xMDAuNSAxMzcuNWw1MC03IDUwIDctNTAtMTIzLjV6Ii8+PHBhdGggZmlsbD0iIzAwMCIgZD0iTTEwNy4yNSAxMzcuNWw0My4yNS03IDQzLjI1IDctNDMuMjUtMTA3eiIvPjxwYXRoIGZpbGw9IiNGQ0QxMTYiIGQ9Ik0xMDAuNSAxMzcuNWgxMDBsLTUwLTYyeiIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-lc.svg
// module id = /tnu
// module chunks = 2